import React, {useCallback, useEffect, useState, useContext, useMemo} from "../../__snowpack__/pkg/react.js";
import {Input, message, Tag, Tooltip} from "../../__snowpack__/pkg/antd.js";
import styled from "../../__snowpack__/pkg/styled-components.js";
import {IconClose, IconPlus} from "../../__snowpack__/pkg/@genieui-react/icon.js";
import LocaleContext from "../../__snowpack__/pkg/antd/es/locale-provider/context.js";
const messageDuration = 1.5;
const i18n = {
  "zh-cn": {
    alreadyExistMsg: "i18n: \u5DF2\u7ECF\u5B58\u5728",
    enterText: "i18n: \u8BF7\u8F93\u5165 (\u4F8B\u5982 \u7EA2\u8272)",
    maxLengthMsg: "i18n: \u8D85\u957F",
    invalidTagCharsMsg: '\u89C4\u683C\u9009\u9879\u6682\u4E0D\u80FD\u8F93\u5165"/"\uFF0C\u8BF7\u68C0\u67E5\uFF01'
  },
  en: {
    alreadyExistMsg: "i18n: Already exist",
    enterText: "i18n: Enter a option (e.g.red)",
    maxLengthMsg: "i18n: Max Length",
    invalidTagCharsMsg: 'The variant option "/" cannot be entered temporarily, Please re-check !'
  },
  id: {
    alreadyExistMsg: "i18n: Already exist",
    enterText: "i18n: Enter a option (e.g.red)",
    maxLengthMsg: "i18n: Max Length",
    invalidTagCharsMsg: 'Pilihan varian tidak dapat menggunakan "/" untuk sementara, silakan cek!'
  },
  vi: {
    alreadyExistMsg: "i18n: Already exist",
    enterText: "i18n: Enter a option (e.g.red)",
    maxLengthMsg: "i18n: Max Length",
    invalidTagCharsMsg: 'T\xF9y ch\u1ECDn t\u1EA1m th\u1EDDi kh\xF4ng th\u1EC3 nh\u1EADp "/", vui l\xF2ng ki\u1EC3m tra!'
  },
  th: {
    alreadyExistMsg: "i18n: Already exist",
    enterText: "i18n: Enter a option (e.g.red)",
    maxLengthMsg: "i18n: Max Length",
    invalidTagCharsMsg: '\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E01\u0E23\u0E2D\u0E01 "/" \u0E44\u0E14\u0E49\u0E0A\u0E31\u0E48\u0E27\u0E04\u0E23\u0E32\u0E27 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A'
  }
};
export const InputTags = (props) => {
  const {maxItemLength, maxLength} = props;
  const {locale} = useContext(LocaleContext);
  const focusInputRef = useCallback((node) => {
    if (node !== null) {
      node.focus();
    }
  }, []);
  const [state, setStateRaw] = useState({
    tags: [],
    inputVisible: false,
    inputValue: "",
    editInputIndex: -1,
    editInputValue: ""
  });
  const isLessMaxLength = useMemo(() => {
    if (maxItemLength != void 0) {
      return state?.tags?.length < maxItemLength;
    }
    return true;
  }, [state.tags, maxItemLength]);
  const getState = () => {
    return new Promise((resolve, reject) => {
      setStateRaw((state2) => {
        resolve(state2);
        return state2;
      });
    });
  };
  const setState = (state2) => {
    setStateRaw(state2);
    setTimeout(() => {
      props.onChange && props.onChange(state2.tags);
    });
  };
  useEffect(() => {
    setStateRaw({
      ...state,
      tags: [...props.value || []]
    });
  }, [props.value]);
  const handleClose = (removedTag) => {
    const tags2 = state.tags.filter((tag) => tag !== removedTag);
    setState({...state, tags: tags2});
  };
  const showInput = () => {
    setState({...state, inputVisible: true});
  };
  const handleInputChange = (e) => {
    setState({...state, inputValue: e.target.value});
  };
  const handleInputConfirm = () => {
    let {inputValue: inputValue2} = state;
    inputValue2 = inputValue2.trim();
    if (!inputValue2) {
      setState({
        ...state,
        inputValue: "",
        inputVisible: false
      });
      return;
    }
    if (props.invalidTagChars && inputValue2.split("").find((_) => props.invalidTagChars?.includes(_))) {
      message.warn(props.invalidTagCharsMsg || i18n[locale].invalidTagCharsMsg, messageDuration);
      setState({
        ...state,
        inputValue: "",
        inputVisible: false
      });
      return;
    }
    if (maxLength && inputValue2.length > maxLength) {
      message.warn(props.maxLengthMsg || i18n[locale].maxLengthMsg, messageDuration);
      setState({
        ...state,
        inputValue: "",
        inputVisible: false
      });
      return;
    }
    if (tags.indexOf(inputValue2) !== -1) {
      message.warn(props.alreadyExistMsg || i18n[locale].alreadyExistMsg, messageDuration);
      setState({
        ...state,
        inputValue: "",
        inputVisible: false
      });
      return;
    }
    setState({
      ...state,
      tags: [...tags, inputValue2],
      inputVisible: false,
      inputValue: ""
    });
  };
  const handleEditInputChange = (e) => {
    setState({...state, editInputValue: e.target.value});
  };
  const handleEditInputConfirm = async () => {
    let v = await getState();
    let {tags: tags2, editInputIndex: editInputIndex2, editInputValue: editInputValue2} = v;
    editInputValue2 = editInputValue2.trim();
    if (!editInputValue2) {
      setState({
        ...state,
        editInputIndex: -1,
        editInputValue: ""
      });
      return;
    }
    if (props.invalidTagChars && inputValue.split("").find((_) => props.invalidTagChars?.includes(_))) {
      message.warn(props.invalidTagCharsMsg || i18n[locale].invalidTagCharsMsg, messageDuration);
      setState({
        ...state,
        inputValue: "",
        inputVisible: false
      });
      return;
    }
    if (maxLength && editInputValue2.length > maxLength) {
      message.warn(props.maxLengthMsg || i18n[locale].maxLengthMsg, messageDuration);
      setState({
        ...state,
        editInputIndex: -1,
        editInputValue: ""
      });
      return;
    }
    if (tags2.includes(editInputValue2)) {
      if (tags2.indexOf(editInputValue2) !== editInputIndex2) {
        message.warn(props.alreadyExistMsg || i18n[locale].alreadyExistMsg, messageDuration);
      }
      setState({
        ...state,
        editInputIndex: -1,
        editInputValue: ""
      });
      return;
    }
    const newTags = [...tags2];
    newTags[editInputIndex2] = editInputValue2;
    setState({
      ...state,
      tags: newTags,
      editInputIndex: -1,
      editInputValue: ""
    });
  };
  const {
    tags,
    inputVisible,
    inputValue,
    editInputIndex,
    editInputValue
  } = state;
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className: "input-tags",
    id: props.id
  }, tags.map((tag, index) => {
    if (editInputIndex === index) {
      return /* @__PURE__ */ React.createElement(Input, {
        ref: focusInputRef,
        key: tag,
        size: "small",
        className: "tag-input",
        value: editInputValue,
        onChange: handleEditInputChange,
        onBlur: handleEditInputConfirm,
        onPressEnter: handleEditInputConfirm
      });
    }
    const isLongTag = tag.length > 20;
    const tagElem = /* @__PURE__ */ React.createElement(Tag, {
      className: `edit-tag ${props.invalidTags?.includes(tag) && "edit-tag-invalid"}`,
      key: tag,
      onClose: () => handleClose(tag),
      closable: !props.unCloseableTags?.includes(tag),
      closeIcon: !props.unCloseableTags?.includes(tag) ? /* @__PURE__ */ React.createElement(IconClose, {
        style: {width: 14, height: 14}
      }) : /* @__PURE__ */ React.createElement(React.Fragment, null)
    }, /* @__PURE__ */ React.createElement("span", {
      onDoubleClick: (e) => {
        if (!props.unCloseableTags?.includes(tag)) {
          setState({
            ...state,
            editInputIndex: index,
            editInputValue: tag
          });
          e.preventDefault();
        }
      }
    }, isLongTag ? `${tag.slice(0, 20)}...` : tag));
    return isLongTag ? /* @__PURE__ */ React.createElement(Tooltip, {
      title: tag,
      key: tag
    }, tagElem) : tagElem;
  }), inputVisible && /* @__PURE__ */ React.createElement(Input, {
    ref: focusInputRef,
    type: "text",
    size: "small",
    className: "tag-input",
    value: inputValue,
    onChange: handleInputChange,
    onBlur: handleInputConfirm,
    onPressEnter: handleInputConfirm
  }), !inputVisible && isLessMaxLength && /* @__PURE__ */ React.createElement(Tag, {
    className: "tag-plus",
    onClick: showInput
  }, /* @__PURE__ */ React.createElement("div", {
    className: "ant-tag-close-icon"
  }, /* @__PURE__ */ React.createElement(IconPlus, {
    style: {width: 12, height: 12},
    primaryColor: "#6020FF"
  })), /* @__PURE__ */ React.createElement("span", {
    className: "tag-plus-label"
  }, props.enterText || i18n[locale].enterText)));
};
const Wrapper = styled.div`
  &.input-tags {
    display: flex;
    flex-wrap: wrap;
    padding: 3px 4px;
    background: #ffffff;
    border-radius: 3px;
    border: 1px solid #adbacc;
    padding-bottom: 0;
  }
  .ant-tag {
    background: #e3e8f0;
    border-radius: 4px;
    font-size: 12px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: #212b36;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 3px;
    .ant-tag-close-icon {
      display: flex;
    }
  }
  .tag-plus {
    max-width: 100%;
    border-radius: 3px;
    border: 1px dashed #adbacc;
    background: #fff;
    .tag-plus-label {
      margin-left: 5px;
      display: block;
      font-size: 12px;
      font-family: SFProText-Medium, SFProText;
      font-weight: 500;
      color: #6020ff;
      line-height: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .tag-input {
    width: 78px;
    margin-bottom: 3px;
    margin-right: 8px;
  }
  .edit-tag-invalid {
    border: 1px solid #ff4d4f;
  }
`;
